import api from '@pray/shared/utils/api';
import logger from '@pray/shared/utils/logger';

import type { ObjectResponse } from '../utils/api/types/response';

export const PRODUCT_TYPES = {
  BANGO: 'bango',
  GIFT: 'gift',
  SUBSCRIPTION: 'subscription',
};

/* eslint-disable camelcase */
export type Product = {
  id: string;
  free_trial_interval: 'day' | 'week' | 'month' | 'year';
  free_trial_interval_count: number;
  subscription_interval: 'day' | 'week' | 'month' | 'year';
  subscription_interval_count: number;
  sku: string;
  sku_bango: string | null;
  sku_dcb: string | null;
  price: number;
  discount?: {
    code: string;
    price: number;
    amount_off?: number;
    percent_off?: number;
  };
};
/* eslint-enable camelcase */

async function fetchActiveProductByType({ type = PRODUCT_TYPES.SUBSCRIPTION, discountCode = null } = {}) {
  let url = `/web/products/active?type=${type}`;
  if (discountCode) url += `&discount_code=${discountCode}`;

  // Weird, but seems that API may return an array or single object
  const response = await api.executeGetRequest<ObjectResponse<Product | Product[]>>(url);
  return response?.data?.data;
}

async function fetchProductById({ id, discountCode }) {
  let url = `/web/products/${id}`;
  if (discountCode) url += `?discount_code=${discountCode}`;

  const response = await api.executeGetRequest<ObjectResponse<Product>>(url);
  return response?.data?.data;
}

async function fetchProductForGifts() {
  const response = await api.executeGetRequest<ObjectResponse<Product>>('/web/products?is_active_for_gifts=true');

  const data = response.data?.data?.[0];

  if (!data) {
    throw new Error('failure getting products active for gifts');
  }

  return data;
}

async function purchaseProductById({ userId, productId, data }) {
  try {
    const url = `/web/users/${userId}/products/${productId}/purchases`;

    const response = await api.executePostRequest<ObjectResponse<unknown>>(url, data);
    return response?.data?.data;
  } catch (err) {
    const error = err.response?.data?.data?.[0];
    logger.error('Error creating product purchase', error);
    throw error;
  }
}

export default {
  fetchActiveProductByType,
  fetchProductById,
  fetchProductForGifts,
  purchaseProductById,
};
